import React, {useCallback, useEffect} from 'react';
import useTranslation from "~/app/hooks/useTranslation";
import {useStoreActions, useStoreState} from '~/store';
import classes from "./style.module.scss";
import AccessControl from "~/accessControl";
import {PERMISSION_GROUPS} from "~/accessControl/permissionGroups";
import useAccessControl from "~/app/hooks/useAccessControl";
import { IssueOrServiceType } from '~/app/data/statuses/chat';

export type HeaderComponent = React.FC<{ type: IssueOrServiceType, counts?: { open: number, completed: number } }>

const Header: HeaderComponent = ({ type, counts }) => {
    const { t } = useTranslation(type === IssueOrServiceType.ISSUE ? 'issues': 'services');
    const basePath = (type === IssueOrServiceType.ISSUE )? 'issue' : 'service';
    const {checkPermission} = useAccessControl();
    const showCompleted = useStoreState(state => state[basePath].showCompleted);
    const setShowCompleted = useStoreActions(actions => actions[basePath].setShowCompleted);

    const clickHandler = useCallback((show) => {
        setShowCompleted(show)
    }, [setShowCompleted]);

    useEffect(() => {
        !(type === IssueOrServiceType.ISSUE
            ? checkPermission(PERMISSION_GROUPS.readFinishedIssues)
            : true
        ) && clickHandler(false);
    }, [checkPermission, clickHandler, type]);

    return (
        <div className={classes['header']}>
            <div className={`${classes['link']} ${!showCompleted && classes['active']}`}
                 onClick={() => clickHandler(false)}>
                {t('open')}
                {counts && <span className={classes['count']}>{counts.open}</span>}
            </div>
            <AccessControl requiredPermissions={PERMISSION_GROUPS.readFinishedIssues}>
                <div className={`${classes['link']} ${showCompleted && classes['active']}`}
                     onClick={() => clickHandler(true)}>
                    {t('completed')}
                    {counts && <span className={classes['count']}>{counts.completed}</span>}
                </div>
            </AccessControl>
        </div>
    );
};

export default Header
